import type { CareerPathResponse } from './careerPath';
import type { Coach } from './coach';
import type { College } from './college';
import type { DeepDive } from './deepDive';
import type { Employer } from './employer';
import type { ExternalProfile } from './externalProfile';
import type { Industry } from './industry';
import type { Internship } from './internship';
import type { Major } from './major';
import type { ContentCompetency, ContentNugget } from './nugget';
import type { PriorityPlaylist } from './playlist';
import type { Scholarship } from './scholarship';
import type { Tool } from './tool';
import type { BackrsUser } from './user';

export const SEARCH_TYPES = {
  NUGGET: 'nugget',
  TOOL: 'tool',
  COMPETENCY: 'competency',
  SCHOLARSHIP: 'scholarship',
  INTERNSHIP: 'internship',
  PROFILE: 'profile',
  CAREER_PATH: 'career_path',
  EXTERNAL_PROFILE: 'external_profile',
  COLLEGE: 'college',
  EMPLOYER: 'employer',
  PLAYLIST: 'playlist',
  MAJOR: 'major',
  INDUSTRY: 'industry',
  COACH: 'coach',
  DEEP_DIVE: 'deep_dive',
} as const;

export type SearchType = (typeof SEARCH_TYPES)[keyof typeof SEARCH_TYPES];

export type SearchResult = Readonly<{
  results: {
    relevance: number;
    result:
      | {
          type: typeof SEARCH_TYPES.NUGGET;
          nugget: ContentNugget;
        }
      | {
          type: typeof SEARCH_TYPES.TOOL;
          tool: Tool;
        }
      | {
          type: typeof SEARCH_TYPES.PLAYLIST;
          playlist: PriorityPlaylist;
        }
      | {
          type: typeof SEARCH_TYPES.COMPETENCY;
          competency: ContentCompetency;
        }
      | {
          type: typeof SEARCH_TYPES.SCHOLARSHIP;
          scholarship: Scholarship;
        }
      | {
          type: typeof SEARCH_TYPES.INTERNSHIP;
          internship: Internship;
        }
      | {
          type: typeof SEARCH_TYPES.PROFILE;
          profile: BackrsUser;
        }
      | {
          type: typeof SEARCH_TYPES.EXTERNAL_PROFILE;
          external_profile: ExternalProfile;
        }
      | {
          type: typeof SEARCH_TYPES.CAREER_PATH;
          career_path: CareerPathResponse;
        }
      | {
          type: typeof SEARCH_TYPES.COLLEGE;
          college: College;
        }
      | {
          type: typeof SEARCH_TYPES.EMPLOYER;
          employer: Employer;
        }
      | {
          type: typeof SEARCH_TYPES.MAJOR;
          major: Major;
        }
      | {
          type: typeof SEARCH_TYPES.INDUSTRY;
          industry: Industry;
        }
      | {
          type: typeof SEARCH_TYPES.COACH;
          coach: Coach;
        }
      | {
          type: typeof SEARCH_TYPES.DEEP_DIVE;
          deep_dive: DeepDive;
        };
  }[];
  page: number;
  perPage: number;
  total: number;
}>;
